import type { ActivityStatus, LogAction, LogEntity, ProjectStatus, Role } from '@/types';
import type { Tone } from '@/components/ui/tones';

export const PROJECT_STATUSES: ProjectStatus[] = ['planning', 'active', 'on_hold', 'completed', 'cancelled'];
export const ACTIVITY_STATUSES: ActivityStatus[] = ['not_started', 'in_progress', 'done', 'on_hold'];
export const ROLES: Role[] = ['admin', 'manager', 'member', 'viewer'];

export const PROJECT_STATUS_LABEL: Record<ProjectStatus, string> = {
  planning: 'วางแผน',
  active: 'กำลังดำเนินการ',
  on_hold: 'พักไว้',
  completed: 'เสร็จสิ้น',
  cancelled: 'ยกเลิก',
};

export const PROJECT_STATUS_TONE: Record<ProjectStatus, Tone> = {
  planning: 'info',
  active: 'primary',
  on_hold: 'warn',
  completed: 'ok',
  cancelled: 'off',
};

export const ACTIVITY_STATUS_LABEL: Record<ActivityStatus, string> = {
  not_started: 'ยังไม่เริ่ม',
  in_progress: 'กำลังทำ',
  done: 'เสร็จแล้ว',
  on_hold: 'พักไว้',
};

export const ACTIVITY_STATUS_TONE: Record<ActivityStatus, Tone> = {
  not_started: 'off',
  in_progress: 'primary',
  done: 'ok',
  on_hold: 'warn',
};

export const ROLE_LABEL: Record<Role, string> = {
  admin: 'Admin',
  manager: 'Manager',
  member: 'Member',
  viewer: 'Viewer',
};

export const ROLE_DESCRIPTION: Record<Role, string> = {
  admin: 'ทุกอย่าง + จัดการผู้ใช้และ API keys',
  manager: 'สร้าง/แก้ไขโปรเจกต์ กิจกรรม baseline เอกสาร และนำเข้า',
  member: 'อัปเดตความคืบหน้า (สถานะ, %, วันที่จริง, หมายเหตุ)',
  viewer: 'ดูอย่างเดียว',
};

export const ROLE_TONE: Record<Role, Tone> = {
  admin: 'bad',
  manager: 'primary',
  member: 'ok',
  viewer: 'off',
};

export const LOG_ACTION_LABEL: Record<LogAction, string> = {
  create: 'สร้าง',
  update: 'แก้ไข',
  delete: 'ลบ',
  import: 'นำเข้า',
};

export const LOG_ACTION_TONE: Record<LogAction, Tone> = {
  create: 'ok',
  update: 'primary',
  delete: 'bad',
  import: 'info',
};

export const LOG_ENTITY_LABEL: Record<LogEntity, string> = {
  project: 'โปรเจกต์',
  activity: 'กิจกรรม',
  document: 'เอกสาร',
};

/** Forecast completion probability → traffic-light tone (≥80% ok, ≥50% warn, else bad). */
export function probabilityTone(p: number | null | undefined): Tone {
  if (p === null || p === undefined || Number.isNaN(p)) return 'off';
  if (p >= 0.8) return 'ok';
  if (p >= 0.5) return 'warn';
  return 'bad';
}
